import React, { createContext, useContext } from 'react';

/**
 * Context for providing the full screen container element
 * This ensures modals, popovers, and other portaled content
 * render within the full screen container when in full screen mode
 */
const FullScreenContext = createContext({
  mountNode: null,
  isFullScreen: false
});

/**
 * Provider component for FullScreenContext
 */
export function FullScreenProvider({ children, mountNode, isFullScreen }) {
  return (
    <FullScreenContext.Provider value={{ mountNode, isFullScreen }}>
      {children}
    </FullScreenContext.Provider>
  );
}

/**
 * Hook to get the appropriate mount node for portaled content
 * Returns the full screen container when in full screen mode,
 * otherwise returns document.body
 */
export function useFullScreenMountNode() {
  const { mountNode, isFullScreen } = useContext(FullScreenContext);
  
  // Return the full screen container if available and in full screen mode
  if (isFullScreen && mountNode) {
    return mountNode;
  }
  
  // Fallback to document.body
  return document.body;
}

/**
 * Hook to get full screen context
 */
export function useFullScreenContext() {
  return useContext(FullScreenContext);
}
